module.exports = "<igo-context-tools igoContextToolsBinding></igo-context-tools>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/tools-context-manager-tool/tools-context-manager-tool.component.html
// module id = 1134
// module chunks = 0